module.exports = __webpack_public_path__ + "img/siemens.10db2215.webp";